define('TescoMobile_AciPayment/js/action/store-payment-info',['jquery', 'Magento_Checkout/js/model/url-builder', 'Magento_Checkout/js/model/full-screen-loader', 'Magento_Customer/js/model/customer', 'mage/storage'], function ($, urlBuilder, fullScreenLoader, customer, storage) {
  'use strict';

  return function (saveCard, cartId) {
    const serviceUrl = urlBuilder.createUrl('/guest-carts/:cartId/storePaymentInfo', {
      cartId: cartId
    });
    const payload = {
      card_details: {
        save_card: saveCard
      }
    };
    fullScreenLoader.startLoader();
    return storage.post(serviceUrl, JSON.stringify(payload)).always(function () {
      fullScreenLoader.stopLoader();
    });
  };
});

